import { render, staticRenderFns } from "./trainingpracticalusers.vue?vue&type=template&id=4945640c&scoped=true"
import script from "./trainingpracticalusers.vue?vue&type=script&lang=js"
export * from "./trainingpracticalusers.vue?vue&type=script&lang=js"
import style0 from "./trainingpracticalusers.vue?vue&type=style&index=0&id=4945640c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945640c",
  null
  
)

export default component.exports